import React from "react";
import AuthContext from '../../store/AuthContext';
import {ChangePassword} from "./ChangePassword";
import {DeleteAccount} from "./DeleteAccount";
import AccountService from "../../services/AccountService"
import { Accordion, FormLabel, FormControl, Button } from 'react-bootstrap';
import Settings from "../../services/SettingsService"
import NativeInterface from "../../services/NativeInterface"
import PropsContainer from "../../components/props/PropsContainer"
import { useLanguage } from "pages/dimension/LanguageContext";

export const Profile = () => {
    const authCtx = React.useContext(AuthContext);
    const langCtx = useLanguage();

    React.useEffect(() => {
        document.title=`DimensionX | Profile`;
    }, []);

    async function updateAccount(props: any) {
        return await authCtx.updateProperties(props)
    }

    function updateSettings(params: any) {
        if (params.web_app_host) {
            NativeInterface.setWebAppHost(params.web_app_host);
        }
        return new Promise<any>((resolve, reject) => {
            Settings.saveProps(params);
            resolve({ok: 1});
        });
    }

    return (
        <Accordion defaultActiveKey="0" alwaysOpen>
            <Accordion.Item eventKey="0">
                <Accordion.Header>{langCtx.translate('General')}</Accordion.Header>
                <Accordion.Body>
                    <PropsContainer properties={authCtx.account.properties} doSave={updateAccount}/>
                </Accordion.Body>
            </Accordion.Item>
            {authCtx.account.settings && (
                <Accordion.Item eventKey="1">
                    <Accordion.Header>{langCtx.translate('Settings')}</Accordion.Header>
                    <Accordion.Body>
                        <PropsContainer properties={Settings.properties} doSave={updateSettings}/>
                    </Accordion.Body>
                </Accordion.Item>
            )}
            <Accordion.Item eventKey="2">
                <Accordion.Header>{langCtx.translate('Logout')}</Accordion.Header>
                <Accordion.Body>
                    <Button variant="warning" style={{ width: "200px"}} onClick={()=>AccountService.logout()}>{langCtx.translate('Logout')}</Button>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
                <Accordion.Header>{langCtx.translate('Change Password')}</Accordion.Header>
                <Accordion.Body>
                    <ChangePassword/>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
                <Accordion.Header>{langCtx.translate('Delete Account')}</Accordion.Header>
                <Accordion.Body>
                    <DeleteAccount/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};
